import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { premiumApi } from '../lib/api';

// Premium perk: members of a premium club browse without AdSense ads.
export const PremiumAdFree = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.club_id) return;
    let cancelled = false;
    premiumApi.info(user.club_id).then((res) => {
      if (cancelled || !res.data?.active) return;
      try {
        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.pauseAdRequests = 1;
      } catch { /* noop */ }
      if (!document.getElementById('premium-adfree-style')) {
        const style = document.createElement('style');
        style.id = 'premium-adfree-style';
        style.innerHTML = 'ins.adsbygoogle, iframe[id^="aswift"], iframe[src*="googleads"], .adsbygoogle-noablate { display: none !important; }';
        document.head.appendChild(style);
      }
    }).catch(() => { /* noop */ });
    return () => { cancelled = true; };
  }, [user?.club_id]);

  return null;
};
